











import { Component, Prop, Vue } from 'vue-property-decorator'
import * as graph from '@shared/types/graphql'
import Redactor from '../Redactor.vue'
import icoLookup from '@/utilities/ico-lookup'

@Component({
  components: {
    Redactor
  }
})
export default class ClientUploadDisplay extends Vue {
  @Prop({ required: true }) upload!: graph.Prototype

  imgSrcValue (upload: graph.Prototype) {
    if (!upload.url) {
      return icoLookup.url
    }
    let srcValue
    const ext: string = upload.url.slice(upload.url.lastIndexOf('.')) || ''
    if ((upload.url.includes('asset') &&
            upload.assetType === 'url' &&
            !['.pdf', '.doc', '.docx'].includes(ext)) || (['.png', '.jpg', '.jpeg', '.gif'].includes(ext) &&
            upload.assetType === '')) {
      srcValue = upload.url
    } else if (upload.url.includes('asset') && upload.assetType && upload.assetType !== 'url') {
      srcValue = icoLookup[upload.assetType]
    } else {
      return icoLookup.url
    }
    return srcValue
  }
}
